var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"bg-transparent z-40",class:[_vm.getClassByAlign, _vm.disablePadding ? '' : 'py-1.5 px-4'],attrs:{"colspan":_vm.colspan}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }